var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"terms-of-use ri-label"},[_vm._v("שיתוף הקישור מהווה הסכמה\n  "),_c('a',{staticClass:"ri-bold-label",attrs:{"href":"https://www.riseup.co.il/ambassadorsregulations","target":"_blank"}},[_vm._v("לתנאי התקנון")])])
}]

export { render, staticRenderFns }